/* eslint-disable no-console */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getCollection } from 'utils';
import { useSnackbar, withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import { Loader, ActionButtons } from 'components';
import ImageUploader from '../ImageUploader/ImageUploader';
import { Collections } from 'app-constants';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: 400
    },
    padding: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  toolbar: theme.mixins.toolbar
}));

function AddImageForm() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [imageData, setImageData] = useState({
    width: '',
    height: ''
  });
  const [isLoading, setIsloading] = useState(false);

  const handleImageData = (data) => setImageData(data);
  const displayMessage = (message, variant) => enqueueSnackbar(message, { variant, preventDuplicate: true });

  const uploadImage = () => {
    setIsloading(true);
    setTimeout(() => {
      const gallery = getCollection(Collections.GALLERY);
      gallery
        .add({
          name: '',
          price: null,
          format: '',
          available: true,
          tehnique: '',
          booked: false,
          image: { ...imageData }
        })
        .then(() => {
          displayMessage('Salvat cu success!', 'success');
          setImageData({
            width: '',
            height: ''
          });
          setIsloading(false);
        })
        .catch((err) => {
          setIsloading(false);
          displayMessage(err.message, 'error');
        });
    }, 2000);
  };

  const { filename, width, height } = imageData;
  const isDataValid = filename && width && height;

  return (
    <form className={classes.root} noValidate autoComplete="off">
      {isLoading && <Loader isLoading={isLoading} />}
      <div className={classes.toolbar} />
      <ActionButtons
        rightAction={uploadImage}
        rightText={'Salvează pe Server'}
        rightDisabled={!isDataValid}
      />
      <ImageUploader getImageInfo={handleImageData} />
    </form>
  );
}

export default withRouter(withSnackbar(AddImageForm));
